import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { House, BookOpen, NotePencil, Waveform, User } from "@phosphor-icons/react";
import ConsentModal from "./ConsentModal";

const TABS = [
  { to: "/", label: "Accueil", icon: House, end: true, testid: "tab-accueil" },
  { to: "/bibliotheque", label: "Fiches", icon: BookOpen, testid: "tab-fiches" },
  { to: "/journal", label: "Journal", icon: NotePencil, testid: "tab-journal" },
  { to: "/meditation", label: "Méditation", icon: Waveform, testid: "tab-meditation" },
  { to: "/profil", label: "Profil", icon: User, testid: "tab-profil" },
];

export function AppFrame({ children }) {
  return (
    <div className="min-h-screen w-full bg-[#EFEAE2]">
      <div className="relative mx-auto min-h-screen w-full max-w-[480px] bg-[#FAF8F5] shadow-[0_0_60px_rgba(54,48,43,0.12)]">
        {children}
      </div>
    </div>
  );
}

export default function Layout() {
  const location = useLocation();
  return (
    <AppFrame>
      <ConsentModal />
      <main key={location.pathname} className="soft-fade pb-28">
        <Outlet />
      </main>
      <nav
        data-testid="bottom-nav"
        className="fixed bottom-0 left-1/2 z-40 w-full max-w-[480px] -translate-x-1/2 border-t border-[#36302B]/5 bg-white/90 px-3 pb-[calc(env(safe-area-inset-bottom)+8px)] pt-2 backdrop-blur-xl"
      >
        <div className="flex items-center justify-between">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={t.testid}
                className="flex flex-1 flex-col items-center gap-1 rounded-2xl py-1.5"
              >
                {({ isActive }) => (
                  <>
                    <Icon
                      size={24}
                      weight={isActive ? "fill" : "regular"}
                      color={isActive ? "#C57B67" : "rgba(54,48,43,0.42)"}
                    />
                    <span
                      className="text-[11px]"
                      style={{
                        color: isActive ? "#C57B67" : "rgba(54,48,43,0.5)",
                        fontWeight: isActive ? 700 : 500,
                      }}
                    >
                      {t.label}
                    </span>
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </AppFrame>
  );
}
